import React from "react";

export default function NewVersionBanner({ visible, onRefresh }) {
  if (!visible) return null;

  return (
    <div
      role="alert"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        padding: "12px 16px",
        background: "#1f2937",
        color: "#fff",
        fontSize: 14,
        boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
      }}
    >
      <span>A new version of this app is available.</span>
      <button
        type="button"
        onClick={onRefresh}
        style={{
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: 4,
          padding: "6px 14px",
          cursor: "pointer",
          fontSize: 14,
        }}
      >
        Refresh
      </button>
    </div>
  );
}
